import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  Center,
  Spinner,
  Image
} from '@chakra-ui/react';

const FullScreenLoader = ({ isOpen }) => {
  return (
    <Modal isOpen={isOpen} onClose={() => {}} isCentered>
      <ModalOverlay />
      <ModalContent
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="transparent"
        boxShadow="none"
      >
        <Center h="100vh">
          {/* <Spinner size="xl" /> */}
          <Image src="/assets/animations/loadingGif.gif" alt="טוען..." />
        </Center>
      </ModalContent>
    </Modal>
  );
};

export default FullScreenLoader;
